/**
 * Phone config
 * - startWith: The starting number of the phone number
 * - lengthRange: Allow another length of the phone number. Min phone length is phoneSpec.length - lengthRange
 */
type PhoneConfig = {
  startWith: string;
  additionalLengths?: number[];
};

export const PHONE_CONFIGS: Record<string, PhoneConfig> = {
  // Indonesia required 08
  ["+62"]: {
    startWith: "08",
    additionalLengths: [10], // old format, BE didn't send old length
  },
  // Pakistan required 03
  ["+92"]: {
    startWith: "03",
  },
};

// Other countries required 0
export const DEFAULT_PHONE_CONFIG: PhoneConfig = {
  startWith: "0",
};
